module.exports = __webpack_public_path__ + "static/media/funfish.8bc44a3f.svg";